const DEFAULT_UNLISTED_POSITION_DATA = {
    department: "Unlisted",
    title: "Jobs",
    location: null,
    positionDescription: null,
    positionRequirements: "<p>Share a little bit about yourself so we can learn more.</p>",
    positionResponsibilities: "<p>Didn't&nbsp;find a position that suits you? You can still apply!</p><p>We’re always looking for amazing people – submit your resume&nbsp;and we’ll get in touch if anything comes up.</p>",
    socialTitle: "monday.com is hiring!",
    socialDescription: "we're on a mission to make people's work simpler, more productive and enjoyable. join monday.com and help us make it happen!",
    employmentType: null,
    teamDescription: null
};
const CAREERS_PAGE = "careers_page";
const POSITION_PAGE = "position_page";
const UNLISTED_POSITION_ID = "8F.007";
module.exports = {
    DEFAULT_UNLISTED_POSITION_DATA,
    CAREERS_PAGE,
    POSITION_PAGE,
    UNLISTED_POSITION_ID
};
